import type { LogPayload } from "./types";

import { datadogEnv } from "./datadog-env";

/**
 * Build a Datadog `ddtags` string from a structured payload.
 * Always overrides `env` with the configured environment when one is set.
 */
function getTagsFromPayload(payload: LogPayload): string | undefined {
  const { environment } = datadogEnv();

  const tags: Record<string, string | number | boolean> = {
    ...payload.tags,
    ...(environment ? { env: environment } : {}),
  };

  const entries = Object.entries(tags);

  if (entries.length === 0) {
    return undefined;
  }

  return entries.map(([key, value]) => `${key}:${value}`).join(",");
}

export { getTagsFromPayload };
